import ACTIONS from "../constants/actions";

const {
  GET_PAYROLL_ALLOWANCE,
  GET_PAYROLL_ALLOWANCE_SUCCESS,
  GET_PAYROLL_ALLOWANCE_FAIL,
  GET_PAYROLL_ALLOWANCE_USER,
  GET_PAYROLL_ALLOWANCE_USER_SUCCESS,
  GET_PAYROLL_ALLOWANCE_USER_FAIL,
  GET_PAYROLL_INSURANCE,
  GET_PAYROLL_INSURANCE_SUCCESS,
  GET_PAYROLL_INSURANCE_FAIL,
  GET_PAYROLL_PIT,
  GET_PAYROLL_PIT_SUCCESS,
  GET_PAYROLL_PIT_FAIL,
  GET_PAYROLL_USERS,
  GET_PAYROLL_USERS_SUCCESS,
  GET_PAYROLL_USERS_FAIL,
  GET_PAYROLL_USER_SETTING,
  GET_PAYROLL_USER_SETTING_SUCCESS,
  GET_PAYROLL_USER_SETTING_FAIL,
  GET_PAYROLL_CONTRATCS,
  GET_PAYROLL_CONTRATCS_SUCCESS,
  GET_PAYROLL_CONTRATCS_FAIL,
  GET_USER_PAYROLL,
  GET_USER_PAYROLL_SUCCESS,
  GET_USER_PAYROLL_FAIL,
  GET_PAYROLL_CONVERSION,
  GET_PAYROLL_CONVERSION_SUCCESS,
  GET_PAYROLL_CONVERSION_FAIL,
  GENERATE_USER_PAYROLL,
  GET_PAYROLL_OVERTIME_USER,
  GET_PAYROLL_OVERTIME_USER_SUCCESS,
  GET_PAYROLL_OVERTIME_USER_FAIL,
  GET_PAYROLL_COMMISION_USER,
  GET_PAYROLL_COMMISION_USER_SUCCESS,
  GET_PAYROLL_COMMISION_USER_FAIL,
  // GET_PAYROLL_COMMISSION_SETTING, GET_PAYROLL_COMMISSION_SETTING_SUCCESS, GET_PAYROLL_COMMISSION_SETTING_FAIL
} = ACTIONS;

const initialState = {
  isLoadingAllowances: false,
  allowances: [],

  isLoadingInsurances: false,
  insurances: [],

  isLoadingPIT: false,
  PITs: [],

  isLoadingPayrollUsers: false,
  payrollUsers: [],

  isLoadingPayrollUserSetting: false,
  payrollUserSetting: [],

  isLoadingContracts: false,
  contracts: [],

  isLoadingUserPayrollDetail: false,
  userPayrollDetail: [],

  isLoadingPayrollConversion: false,
  payrollConversion: {},

  isLoadingCommision: false,
  commissions: [],

  isLoadingCommissionSetting: false,
  commissionSetting: [],
};

const salaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYROLL_ALLOWANCE:
      return {
        ...state,
        isLoadingAllowances: true,
      };
    case GET_PAYROLL_ALLOWANCE_SUCCESS:
      return {
        ...state,
        isLoadingAllowances: false,
        allowances: action.payload,
      };
    case GET_PAYROLL_ALLOWANCE_FAIL:
      return {
        ...state,
        isLoadingAllowances: false,
      };
    case GET_PAYROLL_ALLOWANCE_USER:
      return {
        ...state,
        isLoadingAllowanceUser: true,
      };
    case GET_PAYROLL_ALLOWANCE_USER_SUCCESS:
      return {
        ...state,
        isLoadingAllowanceUser: false,
        allowanceUser: action.payload,
      };
    case GET_PAYROLL_ALLOWANCE_USER_FAIL:
      return {
        ...state,
        isLoadingAllowanceUser: false,
      };
    // case GET_PAYROLL_COMMISSION_SETTING:
    //     return {
    //         ...state,
    //         isLoadingCommissionSetting: true
    //     }
    // case GET_PAYROLL_COMMISSION_SETTING_SUCCESS:
    //     return {
    //         ...state,
    //         isLoadingCommissionSetting: false,
    //         commissionSetting: action.payload,
    //     }
    // case GET_PAYROLL_COMMISSION_SETTING_FAIL:
    //     return {
    //         ...state,
    //         isLoadingCommissionSetting: false
    //     }
    case GET_PAYROLL_COMMISION_USER:
      return {
        ...state,
        isLoadingCommision: true,
      };
    case GET_PAYROLL_COMMISION_USER_SUCCESS:
      return {
        ...state,
        isLoadingCommision: false,
        commissions: action.payload,
      };
    case GET_PAYROLL_COMMISION_USER_FAIL:
      return {
        ...state,
        isLoadingCommision: false,
      };

    case GET_PAYROLL_INSURANCE:
      return {
        ...state,
        isLoadingInsurances: true,
      };
    case GET_PAYROLL_INSURANCE_SUCCESS:
      return {
        ...state,
        isLoadingInsurances: false,
        insurances: action.payload,
      };
    case GET_PAYROLL_INSURANCE_FAIL:
      return {
        ...state,
        isLoadingInsurances: false,
      };

    case GET_PAYROLL_PIT:
      return {
        ...state,
        isLoadingPIT: true,
      };
    case GET_PAYROLL_PIT_SUCCESS:
      return {
        ...state,
        isLoadingPIT: false,
        PITs: action.payload,
      };
    case GET_PAYROLL_PIT_FAIL:
      return {
        ...state,
        isLoadingPIT: false,
      };

    case GET_PAYROLL_USERS:
      return {
        ...state,
        isLoadingPayrollUsers: true,
      };
    case GET_PAYROLL_USERS_SUCCESS:
      return {
        ...state,
        isLoadingPayrollUsers: false,
        payrollUsers: action.payload,
      };
    case GET_PAYROLL_USERS_FAIL:
      return {
        ...state,
        isLoadingPayrollUsers: false,
      };

    case GET_PAYROLL_USER_SETTING:
      return {
        ...state,
        isLoadingPayrollUserSetting: true,
      };
    case GET_PAYROLL_USER_SETTING_SUCCESS:
      return {
        ...state,
        isLoadingPayrollUserSetting: false,
        payrollUserSetting: action.payload,
      };
    case GET_PAYROLL_USER_SETTING_FAIL:
      return {
        ...state,
        isLoadingPayrollUserSetting: false,
      };

    case GET_PAYROLL_CONTRATCS:
      return {
        ...state,
        isLoadingContracts: true,
      };
    case GET_PAYROLL_CONTRATCS_SUCCESS:
      return {
        ...state,
        isLoadingContracts: false,
        contracts: action.payload,
      };
    case GET_PAYROLL_CONTRATCS_FAIL:
      return {
        ...state,
        isLoadingContracts: false,
      };

    case GET_USER_PAYROLL:
      return {
        ...state,
        isLoadingUserPayrollDetail: true,
      };
    case GET_USER_PAYROLL_SUCCESS:
      return {
        ...state,
        isLoadingUserPayrollDetail: false,
        userPayrollDetail: action.payload,
      };
    case GET_USER_PAYROLL_FAIL:
      return {
        ...state,
        isLoadingUserPayrollDetail: false,
        userPayrollDetail: [],
      };

    case GET_PAYROLL_CONVERSION:
      return {
        ...state,
        isLoadingPayrollConversion: true,
      };
    case GET_PAYROLL_CONVERSION_SUCCESS:
      return {
        ...state,
        isLoadingPayrollConversion: false,
        payrollConversion: action.payload,
      };
    case GET_PAYROLL_CONVERSION_FAIL:
      return {
        ...state,
        isLoadingPayrollConversion: false,
      };

    case GENERATE_USER_PAYROLL:
      return {
        ...state,
      };

    case GET_PAYROLL_OVERTIME_USER:
      return {
        ...state,
        isLoadingOvertimeUser: true,
      };
    case GET_PAYROLL_OVERTIME_USER_SUCCESS:
      return {
        ...state,
        isLoadingOvertimeUser: false,
        overtimeUser: action.payload,
      };
    case GET_PAYROLL_OVERTIME_USER_FAIL:
      return {
        ...state,
        isLoadingOvertimeUser: false,
      };

    default:
      return state;
  }
};
export default salaryReducer;
